import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const FilterContext = createContext();

export const useFilter = () => {
    return useContext(FilterContext);
};

export const FilterProvider = ({ children }) => {
    const [issueId, setIssueId] = useState('');
    const location = useLocation()
    const [commonFilter, setCommonFilter] = useState({
        projects: [],
        buckets: []
    });
    const [projectFilter, setProjectFilter] = useState({
        client_id: 0,
        project_ids: [],
        lead_user_code: 0,
        request_user_code: 0,
        project_module_ids: [],
        feature_ids: [],
        issue_id: "",
        flag:false,
        apiCall:false,
        isProjectChange:false
    })

    useEffect(() => {
        if (location?.selectedProject?.length > 0) {
            setCommonFilter((prev) => ({ ...prev, projects: location?.selectedProject }));
        } else if (location?.selectedBucket?.length > 0) {
            setCommonFilter((prev) => ({ ...prev, buckets: location?.selectedBucket }));
        }
    }, [location?.selectedProject])

    return (
        <FilterContext.Provider value={{ commonFilter, setCommonFilter, issueId, setIssueId, projectFilter, setProjectFilter }}>
            {children}
        </FilterContext.Provider>
    );
};
